module.exports = __webpack_public_path__ + "assets/img/w1.176ca0cf.jpg";